import { gql } from '@apollo/client';

const CREATE_USER = gql`
  mutation createUser($user: UserCreateInput!,) {
    createUser(user: $user) {
      success
      message
      user {
        id
      }  
    }
  }
`;

const GET_LOCATIONS = gql`
  query locations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
      }
    }
  }
`;

export { CREATE_USER, GET_LOCATIONS }
